// @flow

import React from 'react'

type Props = {
  children?: React$Node,
  className?: string,
  title?: string,
  colorClass?: string,
  borderClass?: string,
  backgroundClass?: string,
  onClick?: Function,
  disabled?: boolean,
}

const ColorButton = ({
  children,
  className = '',
  title = '',
  colorClass = '',
  borderClass,
  backgroundClass = '',
  onClick,
  disabled,
}: Props) => {
  const cursor = disabled ? 'default' : 'pointer'
  const border = borderClass ? borderClass + ' ba' : ''
  return (
    <div
      title={title}
      onClick={e => {
        if (disabled) {
          return
        }
        return onClick ? onClick(e) : null
      }}
      disabled={disabled}
      className={`${className} dib tc f6 pv2 ph3 nowrap ${cursor} ${colorClass} ${backgroundClass} ${border}`}
    >
      {children}
    </div>
  )
}

export default ColorButton



// WEBPACK FOOTER //
// ./src/components/Controls/ColorButton.js